var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransferBacteriaSampleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52602",
    "data-name": "Group 52602",
    transform: "translate(-712.087 -2674.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18627",
    "data-name": "Rectangle 18627",
    transform: "translate(712.087 2674.968)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_15_",
    "data-name": "svgexport-7 (15)",
    transform: "translate(703.453 2665.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52542",
    "data-name": "Group 52542",
    transform: "translate(18.72 21.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91016",
    "data-name": "Path 91016",
    d: "M39.084,67.937c-.226.055-.515.8-.246,1.845s.869,1.567,1.088,1.5c.19-.049.5-.755.221-1.84-.26-1-.822-1.5-1.063-1.5Z",
    transform: "translate(-24.627 -34.998)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91017",
    "data-name": "Path 91017",
    d: "M53.934,58.714c.19-.049.5-.755.221-1.84-.261-1-.822-1.5-1.064-1.5-.215.053-.527.76-.246,1.845C53.116,58.255,53.72,58.781,53.934,58.714Z",
    transform: "translate(-28.761 -31.288)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91018",
    "data-name": "Path 91018",
    d: "M60.923,36.376c-1.133,0-1.731.467-1.733.658s.645.683,1.719.695l.041.7v-.7c1.095,0,1.689-.467,1.692-.657S62.045,36.39,60.923,36.376Z",
    transform: "translate(-30.667 -25.681)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91019",
    "data-name": "Path 91019",
    d: "M49.094,81.193a2.657,2.657,0,0,0-1.461-.595.432.432,0,0,0-.321.087c-.118.155.073.9.963,1.585a2.659,2.659,0,0,0,1.46.595.432.432,0,0,0,.321-.087c.119-.156-.071-.9-.963-1.585Z",
    transform: "translate(-27.151 -38.735)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91020",
    "data-name": "Path 91020",
    d: "M47.247,41.51a1.273,1.273,0,0,0-.45-1.138.649.649,0,0,0-.323-.076,3.654,3.654,0,0,0-2.523,2.127,5.011,5.011,0,0,0-.673,2.362,1.273,1.273,0,0,0,.45,1.138c.591.326,1.93-.394,2.846-2.051a5.011,5.011,0,0,0,.673-2.362Z",
    transform: "translate(-25.97 -26.838)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91021",
    "data-name": "Path 91021",
    d: "M80.8,58.465c.641-.3.793-1.859.035-3.508-.69-1.5-1.763-2.31-2.421-2.31a.608.608,0,0,0-.264.055c-.642.295-.794,1.858-.037,3.508C78.908,57.933,80.187,58.748,80.8,58.465Z",
    transform: "translate(-36.103 -30.484)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91022",
    "data-name": "Path 91022",
    d: "M98.053,94.579l-25.1-25.1a2.3,2.3,0,0,1-.421.578,2.273,2.273,0,0,1-.586.409l25.11,25.11a.721.721,0,0,0,1,0,.7.7,0,0,0,0-1Z",
    transform: "translate(-34.433 -35.453)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91023",
    "data-name": "Path 91023",
    d: "M46.207,73.179A24.526,24.526,0,1,1,66.453,62.446l2.16,2.161a27.228,27.228,0,0,0,5.081-15.918,27.511,27.511,0,1,0-7.806,19.174l-2.117-2.119a24.549,24.549,0,0,1-17.564,7.436Z",
    transform: "translate(-18.72 -21.201)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91024",
    "data-name": "Path 91024",
    d: "M67.3,61.951a5.551,5.551,0,0,0-3.468-1.792,1.212,1.212,0,0,0-.889.3,1.731,1.731,0,0,0-.183,1.68,6.474,6.474,0,0,0,1.674,2.675,5.788,5.788,0,0,0,3.263,1.777.686.686,0,0,1,.224.014,1.2,1.2,0,0,0,.869-.3,1.265,1.265,0,0,0,.289-.928.636.636,0,0,1,0-.175,3.121,3.121,0,0,0-.1-.577A6.473,6.473,0,0,0,67.3,61.951Z",
    transform: "translate(-31.685 -32.702)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91025",
    "data-name": "Path 91025",
    d: "M59.351,55.344l7.93,7.93a23.028,23.028,0,1,0-2.661,3.318l-8.258-8.257a7.132,7.132,0,0,1-4.046-2.177,7.787,7.787,0,0,1-2.035-3.293,3.013,3.013,0,0,1,.543-3.055,2.593,2.593,0,0,1,1.886-.715A6.784,6.784,0,0,1,57.174,51.3a7.8,7.8,0,0,1,2.035,3.295,4.738,4.738,0,0,1,.142.75ZM55.01,66.2l2.238-2.471a.7.7,0,1,1,1.045.947l-2.238,2.471A.7.7,0,1,1,55.01,66.2Zm-10.5-20.434c1.133-.295,2.367.817,2.809,2.511.449,1.731-.08,3.26-1.231,3.559a1.5,1.5,0,0,1-.38.049c-1.037,0-2.035-1.052-2.426-2.559-.449-1.728.079-3.259,1.228-3.559Zm-12.768-.517-1.233,2.114a.7.7,0,0,1-1.218-.71l1.233-2.114a.7.7,0,1,1,1.218.71Zm4.473,15.444a1.5,1.5,0,0,1-.38.049c-1.037,0-2.035-1.052-2.426-2.558-.45-1.731.079-3.262,1.23-3.56,1.12-.29,2.366.817,2.807,2.51.448,1.73-.081,3.26-1.231,3.559ZM38.3,43.575c-.438.8-1.2,2.606-.187,4.172a.7.7,0,1,1-1.183.767,5.451,5.451,0,0,1,.143-5.638,2.9,2.9,0,0,1-.61-1.868,6.353,6.353,0,0,1,.849-3.06c.959-1.734,2.434-2.854,3.757-2.854a2.062,2.062,0,0,1,1,.252A2.56,2.56,0,0,1,43.252,37.7a6.353,6.353,0,0,1-.849,3.06c-.959,1.734-2.434,2.854-3.757,2.854a2.047,2.047,0,0,1-.345-.041Zm9.321,25.36a3.089,3.089,0,0,1-1.3.285A4.107,4.107,0,0,1,44.01,68.4a2.014,2.014,0,0,1-.861.182,3.993,3.993,0,0,1-2.315-.884c-1.421-1.085-1.949-2.615-1.23-3.56.695-.911,2.406-.789,3.759.242a3.212,3.212,0,0,1,1.506,2.9,2.24,2.24,0,0,0,2.166.368.7.7,0,0,1,.586,1.282Zm.844-8.317a.706.706,0,0,1-.985-.157L46.2,58.7a.7.7,0,0,1,1.141-.828l1.278,1.762A.705.705,0,0,1,48.466,60.618ZM52,43.5a.705.705,0,0,1-.976-.2l-.8-1.214A.7.7,0,1,1,51.4,41.31l.8,1.214a.705.705,0,0,1-.2.976Zm-1.15-7h-.057c-1.787-.02-3.126-.932-3.112-2.121.014-1.17,1.35-2.052,3.107-2.052,1.84.023,3.178.935,3.164,2.123-.014,1.169-1.347,2.05-3.1,2.05Zm10.338-.632a.706.706,0,0,1,.972.22l1.642,2.6a.7.7,0,0,1-1.193.752l-1.642-2.6A.705.705,0,0,1,61.187,35.872Zm-3.634,5.147a.7.7,0,0,1,.745-.662,5.449,5.449,0,0,1,4.454,3.455c.043,0,.082-.013.126-.013,1.352,0,2.84,1.258,3.7,3.131,1.072,2.334.752,4.7-.727,5.378a2.031,2.031,0,0,1-.854.183c-1.352,0-2.84-1.259-3.7-3.131-.918-2-.808-4,.166-4.972a4.13,4.13,0,0,0-3.247-2.623A.7.7,0,0,1,57.553,41.019Z",
    transform: "translate(-20.565 -23.046)",
    fill: "#93a750"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferBacteriaSampleIcon);
export default __webpack_public_path__ + "static/media/TransferBacteriaSampleIcon.ddd9d14db82f65c1379701f82779181e.svg";
export { ForwardRef as ReactComponent };